export default "__VITE_ASSET__$53A4HSx__"